module.exports = __webpack_public_path__ + "static/media/3D.629622e3.svg";